"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyRegistrationRepository = void 0;
class CompanyRegistrationRepository {
    constructor(client) {
        this.clientWithRetry = client.clientWithRetry;
        this.clientWithoutRetry = client.clientWithoutRetry;
    }
    getCompanyRegistrationsByReference(companyReference) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithoutRetry.get(`/company_registrations?companyReference=${companyReference}`);
            return data;
        });
    }
    getCompanyRegistrationsByName(companyName) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithoutRetry.get(`/company_registrations?companyName=${companyName}`);
            return data;
        });
    }
    getCompanyRegistrationsByShopRegistrationNumber(shopRegistrationNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithoutRetry.get(`/company_registrations?shopRegistrationNumber=${shopRegistrationNumber}`);
            return data;
        });
    }
    getCompanyRegistrationsByOrganisationRegistrationNumber(organisationRegistrationNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithoutRetry.get(`/company_registrations?organisationRegistrationNumber=${organisationRegistrationNumber}`);
            return data;
        });
    }
}
exports.CompanyRegistrationRepository = CompanyRegistrationRepository;
//# sourceMappingURL=CompanyRegistrationRepository.js.map